import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import RevenueCalculatorResultMetric from './RevenueCalculatorResultMetric';
import { cssVar } from 'src/app/styles/helper';

export interface RevenueCalculatorResultsBlockProps {
  title: string;
  value: string;
  subtitle?: string;
  bottomLeftLabel?: string;
  bottomLeftValue?: string;
  bottomLeftHint?: string;
  bottomRightLabel?: string;
  bottomRightValue?: string;
  bottomRightHint?: string;
}

const RevenueCalculatorResultsBlock = ({
  title,
  value,
  subtitle,
  bottomLeftLabel,
  bottomLeftValue,
  bottomLeftHint,
  bottomRightLabel,
  bottomRightValue,
  bottomRightHint,
}: RevenueCalculatorResultsBlockProps): JSX.Element => {
  const borderStyle = `1px solid ${cssVar('border-brand-alt')}`;
  const hintColor = cssVar('gray-light-700');

  return (
    <Stack
      direction='column'
      background='gradient-linear-01'
    >
      <Stack
        direction='column'
        gap='spacing-md'
        padding='spacing-5xl'
        margin='spacing-auto'
      >
        <Typography
          text={title}
          type='heading'
          size='md'
          as='p'
          textAlign='center'
        />
        <Typography
          text={value}
          type='heading'
          size='2xl'
          as='p'
          fontWeight='font-weight-semibold'
          textAlign='center'
        />
        {subtitle && (
          <Typography
            text={subtitle}
            type='paragraph'
            size='md'
            textAlign='center'
            fontWeight='font-weight-medium'
          />
        )}
      </Stack>
      {(bottomLeftLabel || bottomRightLabel) && (
        <Grid
          totalColumns={2}
          gap='spacing-none'
          borderTop={borderStyle}
        >
          {bottomLeftLabel && bottomLeftValue && (
            <Stack
              borderRight={borderStyle}
              padding='spacing-2xl'
              justify='center'
              align='center'
            >
              <RevenueCalculatorResultMetric
                label={bottomLeftLabel}
                value={bottomLeftValue}
                hint={bottomLeftHint}
                hintColor={hintColor}
              />
            </Stack>
          )}
          {bottomRightLabel && bottomRightValue && (
            <Stack
              padding='spacing-2xl'
              justify='center'
              align='center'
            >
              <RevenueCalculatorResultMetric
                label={bottomRightLabel}
                value={bottomRightValue}
                hint={bottomRightHint}
                hintColor={hintColor}
              />
            </Stack>
          )}
        </Grid>
      )}
    </Stack>
  );
};

export default RevenueCalculatorResultsBlock;
